export interface FilterConfig {
  key: string;
  label: string;
  displayName: string;
  dataPath?: string; // Path in Redux state
  idField: string;
  nameField: string;
  searchPlaceholder: string;
  hasQueryOutput?: boolean;
  directDataPath?: string;
}

export const FILTER_CONFIGS: FilterConfig[] = [
  {
    key: "trafficsource",
    label: "Traffic Source",
    displayName: "Select Traffic Source",
    directDataPath: "trafficSourceData",
    idField: "traffic_source_name",
    nameField: "traffic_source_name",
    searchPlaceholder: "Search traffic source...",
    hasQueryOutput: false,
  },
  {
    key: "country",
    label: "Country",
    displayName: "Select Country",
    directDataPath: "geoData",
    idField: "name",
    nameField: "name",
    searchPlaceholder: "Search country...",
    hasQueryOutput: false,
  },
  {
    key: "campaignId",
    label: "Campaign",
    displayName: "Select Campaign",
    dataPath: "campaign",
    idField: "camp_id",
    nameField: "camp_name",
    searchPlaceholder: "Search campaign...",
    hasQueryOutput: true,
  },
  {
    key: "adgroupId",
    label: "Adgroup",
    displayName: "Select Adgroup",
    dataPath: "adgroup",
    idField: "ag_id",
    nameField: "ag_name",
    searchPlaceholder: "Search adgroup...",
    hasQueryOutput: true,
  },
  {
    key: "kwId",
    label: "Keyword",
    displayName: "Select Keyword",
    dataPath: "keyword",
    idField: "kw_id",
    nameField: "kw_name",
    searchPlaceholder: "Search keyword...",
    hasQueryOutput: true,
  },
];
